module.exports = __webpack_public_path__ + "img/pic_dontmissout_paypal@3x.fca7d792.png";